// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__igDew","body2":"About_body2__30uyV","body":"About_body__2JPfF","pictureContainer":"About_pictureContainer__UnL5k","wrapper":"About_wrapper__2ofKf"};